import { createUseStyles } from 'react-jss';

import { FontWeight } from '../../../../styles';
import { ITheme } from '../../../../styles/theme';

const useStyles = createUseStyles<string>(
  ({ colors }: ITheme) => ({
    root: {
      cursor: 'pointer',
      position: 'relative',
      display: 'inline-block',

      '&.disabled': {
        opacity: '.5',
      },

      '&:focus-visible': {
        borderColor: 'transparent',
        outline: 'none',
      },

      '&.selected': {
        cursor: 'default',
      },

      // '&:focus-within:not(.disabled)': {
      //   '& $label': {
      //     color: colors.primary,
      //   },
      // },
    },
    control: {
      opacity: 0,
      position: 'absolute',
      left: '0',
      top: '0',
      width: '24px',
      height: '24px',
    },
    label: {
      fontWeight: FontWeight.Medium,
      fontSize: '1rem',
      color: '#000000',
      display: 'inline-block',
      verticalAlign: 'middle',

      userSelect: 'none',
    },
    icon: {
      width: '20px',
      height: '20px',
      display: 'inline-block',
      position: 'relative',
      verticalAlign: 'middle',
      marginInlineEnd: '8px',
      borderRadius: '100%',
      border: `2px solid gray`,

      '&.active': {
        border: `2px solid ${colors.secondary}`,
      },

      '& > .check': {
        display: 'inline-block',
        width: '10px',
        height: '10px',
        position: 'absolute',
        top: '50%',
        left: '50%',
        marginTop: '-5px',
        marginInlineStart: '-5px',
        background: colors.secondary,
        borderRadius: '100%',
      },
    },
  }),
  {
    name: 'radio',
  },
);

export default useStyles;
